export enum TellentOrgChannelEvent {
  BillingInformationUpdated = 'billing_information_updated',
}
